module.exports = __webpack_public_path__ + "static/media/background.c4c8e2d9.png";